// SSE 실시간 이벤트의 입력 경계 파서. 모든 이벤트 핸들러가 이 순수 함수들을 거쳐
// 페이로드를 읽으므로, 여기서 회귀가 나면 전 이벤트 처리가 조용히 깨진다.
// 격리 단위 테스트로 현행 동작을 고정하기 위해 RealtimeEventsProvider에서 분리했다.

type RealtimeEnvelope = {
  type?: unknown;
  payload?: unknown;
};

export const getStringField = (payload: unknown, field: string): string | null => {
  if (!payload || typeof payload !== 'object') return null;
  const value = (payload as Record<string, unknown>)[field];
  return typeof value === 'string' && value.length > 0 ? value : null;
};

export const getUnreadCountFromPayload = (payload: unknown): number | null => {
  if (!payload || typeof payload !== 'object') return null;
  const unreadCount = (payload as { unreadCount?: unknown }).unreadCount;
  return typeof unreadCount === 'number' && Number.isFinite(unreadCount) ? unreadCount : null;
};

export const shouldShowDesktopNotification = (payload: unknown): boolean => {
  if (!payload || typeof payload !== 'object') return false;
  return (payload as { showDesktopNotification?: unknown }).showDesktopNotification !== false;
};

export const parseRealtimePayload = (event: MessageEvent): unknown => {
  const parsed = JSON.parse(event.data) as RealtimeEnvelope;
  if (parsed && typeof parsed === 'object' && 'payload' in parsed) {
    return parsed.payload;
  }
  return parsed;
};
